import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';

export interface MemberTemplate {
  templateName: string,
  name: string,
  description: string,
}

@Component({
  selector: 'app-member-certificate',
  templateUrl: './member-certificate.component.html',
  styleUrls: ['./member-certificate.component.scss']
})
export class MemberCertificateComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService
  ) { }

  certificates: any = []
  imgUrl: string = environment.ImageUrl
  listStatus: any = [
    'Pending',
    'Approved',
    'Rejected'
  ]

  ngOnInit(): void {
    this.initData()
  }

  initData() {
    this.auth.certificateFetch().subscribe((response: any) => {
      this.certificates = response.body
    })
  }

  handleApproval(event: any, item: any) {
    const status = event.target.value
    this.local.alertConfirm({
      message: 'Are you sure you want to change the approval status?'
    }).then((resp) => {
      if (resp.isConfirmed) {
        this.auth.certificateChangeStatus({
          id: item.id,
          status: status
        }).subscribe((response: any) => {
          this.toastr.success(response.message)
          this.initData()
        }, (e) => {
          this.toastr.error("Failed")
          this.initData()
        })
      }
    })
  }

  handleDelete(item: any) {
    this.local.alertConfirm({}).then((resp) => {
      if (resp.isConfirmed) {
        this.auth.certificateDelete({
          id: item.id,
        }).subscribe((response: any) => {
          this.toastr.success(response.message)
          this.initData()
        }, (e) => {
          this.toastr.error("Failed")
          this.initData()
        })
      }
    })
  }
}
